import React, {useEffect, useRef} from "react";
import PropTypes from "prop-types";
import styles from "../bigScreen.less";

function AppList(props) {
  const { model, getLangMsg, appList, defaultappdid, getBizData } = props
  const appListRef = useRef(null)
  // useEffect(() => {
  //   defaultappdid && model.invoke('liststatistics', `{"bizappid": "${defaultappdid}"}`)
  // }, [defaultappdid])

  // 应用更新后，默认第一个应用选中效果
  useEffect(() => {
    if (appList && appList.length > 0) {
      let defaultIndex = 0
      appList.forEach((item, index) => {
        if (item.id === defaultappdid) {
          defaultIndex = index
          return
        }
      })
      const trList = appListRef.current.getElementsByTagName('tr')
      trList.forEach((item, index) => {
        // item.className = index === 1 
        item.className = index === defaultIndex + 1
          ?`${styles.app} ${styles.activeapp}`
          : `${styles.app}`
      })
    }
  }, [appList])
  // 获取应用下模型资产统计列表
  const handleClick = (id, e) => {
    getBizData(id)
    const trList = appListRef.current.getElementsByTagName('tr')
    trList.forEach(item => {
      if (item === e.target || item === e.target.parentElement) {
        item.className = `${styles.app} ${styles.activeapp}`
      } else {
        item.className = `${styles.app}`
      }
    })
  }
  
  // appDetailsData = appList.length>0?appList:appDetailsData
  return (
    <div className={styles.appList} ref={appListRef}>
      <table>
        <thead>
          <tr>
            <td style={{width: '70px'}} title={getLangMsg('appList.key0001')}>{getLangMsg('appList.key0001')}</td>
            <td style={{width: '110px'}} title={getLangMsg('appList.key0002')}>{getLangMsg('appList.key0002')}</td>
          </tr>
        </thead>
        {/* <div> */}
        <tbody>
          {appList.map((item, index) => {
            return (
              <tr key={index} onClick={(e)=>handleClick(item.id,e)} className={styles.app}>
                <td style={{width: '70px'}} title={item.number}>{item.number}</td>
                <td style={{width: '110px'}} title={item.name}>{item.name}</td>
              </tr>
            );
          })}
        </tbody>
        {/* </div> */}
      </table>
    </div>
  );
}
AppList.propTypes = {
  baseinfo: PropTypes.object,
  name: PropTypes.string,
};
export default AppList;
